// app/javascript/controllers/submit_overlay_controller.js
import { Controller } from "@hotwired/stimulus"

// Intercepts the native form submit, uploads via fetch, and keeps the
// overlay visible with real-time status.  On success → redirect.
// On failure → show the error in the overlay with a dismiss button
// so the user's form data (including file selections) is never lost.
export default class extends Controller {
  static targets = ["overlay", "status", "detail", "actions"]

  connect() {
    this.overlayTarget.classList.add("hidden")
    this.enableButtons()
  }

  submit(event) {
    event.preventDefault() // stop Turbo / native submit

    const form = this.element
    const formData = new FormData(form)

    this.showOverlay("Submitting. Please be patient.", "Uploading files to Paravel Global...")
    this.disableButtons()

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(form.action, {
      method: form.method || "POST",
      body: formData,
      headers: {
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken
      }
    })
    .then(async (response) => {
      let data
      try {
        data = await response.json()
      } catch {
        throw new Error(`Server returned ${response.status} — please try again.`)
      }

      if (response.ok && data.redirect_to) {
        this.showOverlay("Success!", data.message || "Release submitted successfully.")
        window.location.href = data.redirect_to
      } else {
        const message = data.error || data.errors?.join(", ") || "Something went wrong."
        this.showError(message)
      }
    })
    .catch(error => {
      this.showError(error.message || "Network error. Please check your connection and try again.")
    })
  }

  showOverlay(heading, detail) {
    this.statusTarget.textContent = heading
    this.detailTarget.textContent = detail || ""
    this.actionsTarget.classList.add("hidden")
    this.overlayTarget.classList.remove("hidden")
  }

  showError(message) {
    this.statusTarget.textContent = "Submission Failed"
    this.statusTarget.classList.remove("text-white")
    this.statusTarget.classList.add("text-red-400")
    this.detailTarget.textContent = message
    this.detailTarget.classList.remove("text-zinc-400")
    this.detailTarget.classList.add("text-zinc-300")
    this.actionsTarget.classList.remove("hidden")
    this.enableButtons()
  }

  dismiss() {
    this.overlayTarget.classList.add("hidden")
    // Reset overlay text colors for next attempt
    this.statusTarget.classList.remove("text-red-400")
    this.statusTarget.classList.add("text-white")
    this.detailTarget.classList.remove("text-zinc-300")
    this.detailTarget.classList.add("text-zinc-400")
  }

  disableButtons() {
    this.element.querySelectorAll('input[type="submit"], button[type="submit"]').forEach(btn => {
      btn.disabled = true
    })
  }

  enableButtons() {
    this.element.querySelectorAll('input[type="submit"], button[type="submit"]').forEach(btn => {
      btn.disabled = false
    })
  }
}
